import React from "react";
import { createRoot } from "react-dom/client";

import { Root } from "@apps/mf-overview/src/ts/components/Root";

/**
 * Render the application within the DOM.
 */
const root = createRoot(document.getElementById("app")!);
root.render(<Root />,);
